import React from "react";
import { connect } from "react-redux";
import PoliciesHeader from "./Components/PoliciesHeader/PoliciesHeader";
import PoliciesWrapper from "./Components/PoliciesWrapper/PoliciesWrapper";
import { getPoliciesDcpRequest } from "./Redux/actions";
import { policiesStatusEnum } from "../lib/enum";
import { getPartnerGuid, getUserBranch } from "../../../lib/access.es6";

class PoliciesDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      size: 10,
    }
  }

  componentWillMount() {
    const payload = {
      "status": policiesStatusEnum.Un_Confirmed,
    }

    const partnerGuid = getPartnerGuid();
    if (partnerGuid === "accessbank") {
      payload['branch'] = getUserBranch();
    }

    this.props.dispatch(getPoliciesDcpRequest(payload))
  }


  getPolicies(payload = {}) {
    const page = payload.page || 1;
    const size = payload.size || 10;
    const status = payload.status || policiesStatusEnum.Un_Confirmed;
    const requestPayload = { ...payload, page, size, status };

    const partnerGuid = getPartnerGuid();
    if (partnerGuid === "accessbank") {
      requestPayload['branch'] = getUserBranch();
    }

    this.props.dispatch(getPoliciesDcpRequest(requestPayload));
  }


  render() {

    return (
      <>
        <PoliciesHeader
          title="Policies Dashboard"
        />

        <PoliciesWrapper
          getPolicies={this.getPolicies.bind(this)}
          policies={this.props.PoliciesDashboardData.policies_dcp.data}
          loader={this.props.PoliciesDashboardData.get_policies_dcp_loader}
          page={this.props.PoliciesDashboardData.policies_dcp.page}
          size={this.props.PoliciesDashboardData.policies_dcp.size}
          total={this.props.PoliciesDashboardData.policies_dcp.total}
        />

      </>
    )

  }

}
export default connect((state) => ({
  profileData: state.profile,
  customerData: state.currentCustomer,
  PoliciesDashboardData: state.PoliciesDashboardData,
  globalData: state.global,
}))(PoliciesDashboard);